import { ApiProperty } from '@nestjs/swagger';
import { Column, Entity, PrimaryGeneratedColumn, VersionColumn, UpdateDateColumn, CreateDateColumn, ManyToOne, JoinColumn } from 'typeorm';
import { Route } from '../routes/entity/route.entity';

@Entity('pickup')
export class PickUp {

    @PrimaryGeneratedColumn('increment', { name: 'pickup_id' })
    pickUpId: number;

    @Column('varchar', {
        nullable: false,
        length: 50,
        name: 'pickup'
    })
    pickUp: string;

    @Column('boolean', {
        nullable: false,
        default: true,
        name: 'is_active'
    })
    isActive: boolean;

    @CreateDateColumn({
        name: 'created_at',
        type: 'datetime',
    })
    createdAt: Date;

    @Column('varchar', {
        nullable: false,
        name: 'created_user'
    })
    createdUser: string | null;

    @UpdateDateColumn({
        name: 'updated_at',
        type: 'datetime',
    })
    updatedAt: Date;

    @Column('varchar', {
        nullable: true,
        name: 'updated_user'
    })
    updatedUser: string | null;

    @VersionColumn({
        default: 1,
        name: 'version_flag'
    })
    versionFlag: number;

    // @ManyToOne(type => Route, info => info.pickUpPoints, { nullable: true })
    // @JoinColumn({ name: 'route_id' })
    // route: Route;
}